import React from 'react';
import Button from 'carbon-react/lib/components/button';

import { FormattedMessage } from '@futrli/localisation';
import { useSidebarContext } from '@futrli/shared-services/contexts/sidebar-context/useSidebarContext';

import { PopoverMenu, PopoverMenuItem } from '@futrli/ui-components/components/popover-menu/popover-menu';

export const CreateReportingPopover = () => {
  const { report, template } = useSidebarContext();

  const items: PopoverMenuItem[] = [
    {
      label: <FormattedMessage id="reporting.report" defaultMessage="Report" />,
      onClick: () => report.open()
    },
    {
      label: <FormattedMessage id="predict.create.report_template_v2" defaultMessage="Report template" />,
      onClick: () => template.open()
    }
  ];

  return (
    <PopoverMenu
      items={items}
      renderOpenComponent={({ onClick, ref, 'aria-expanded': ariaExpanded }) => (
        <Button
          buttonType="primary"
          iconType="dropdown"
          iconPosition="after"
          onClick={onClick}
          ref={ref}
          aria-expanded={ariaExpanded}
        >
          <FormattedMessage id="common.create" defaultMessage="Create" />
        </Button>
      )}
    />
  );
};
